module.exports = __webpack_public_path__ + "static/media/buttons.0cfde8d2.svg";